export default __webpack_public_path__ + "static/media/about.bcb172d4.jpg";